<template>
    <div class="reset-password-form">
        <h3 style="margin-top:0">{{getText('form_reset_password_title')}}</h3>
        <el-form
            ref="resetPasswordForm"
            :model="resetPasswordForm"
            :rules="resetPasswordFormRules"
        >
            <el-form-item prop="password">
                <el-input
                    v-model="resetPasswordForm.password"
                    type="password"
                    :placeholder="getText('form_reset_password_placeholder_password')"
                ></el-input>
            </el-form-item>
            <el-form-item prop="confirm">
                <el-input
                    v-model="resetPasswordForm.confirm"
                    type="password"
                    :placeholder="getText('form_reset_password_placeholder_confirmation')"
                ></el-input>
            </el-form-item>
            <el-row :gutter="10" class="reset-password-form-buttons">
                <el-col :span="12">
                    <el-button
                        style="width:100%"
                        :loading="isSaving"
                        @click="resetResetForm"
                        class="whiteButton"
                    >
                        {{getText('cancel_button')}}
                    </el-button>
                </el-col>
                <el-col :span="12">
                    <el-button
                        style="width:100%"
                        type="primary"
                        :loading="isSaving"
                        @click="submitResetForm"
                        class="greenButton"
                    >
                        {{getText('save_button')}}
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>

import axios from 'axios';
import {mapGetters} from 'vuex';

export default {

    components: {

    },

    props: {

    },

    data: function(){
        const validatePass = (rule, value, cb) => {
            if (value === '') {
                cb(new Error(this.getText('form_reset_password_empty_password_error')));
            }else if(value.length < 8){
                cb(new Error(this.getText('form_reset_password_empty_password_too_short_error')));
            } else {
                this.$refs.resetPasswordForm.validateField('confirm');
                cb();
            }
        };
        const confirmValidatePass = (rule, value, cb) => {
            if (value === '') cb(new Error(this.getText('form_reset_password_empty_password_confirmation_error')));
            else if (value !== this.resetPasswordForm.password) cb(new Error(this.getText('form_reset_password_and_confirmation_password_no_match')));
            else cb();
        };
        return {

            resetPasswordForm: {
                password: '',
                confirm: ''
            },
            resetPasswordFormRules: {
                password: [{
                    validator: validatePass,
                    trigger: 'blur'
                }],
                confirm: [{
                    validator: confirmValidatePass,
                    trigger: 'blur'
                }]
            },
            isSaving: false,
        };
    },

    computed: {
        ...mapGetters([
            'getText',
            'currentUser'
        ])
    },

    mounted: function(){

    },

    methods: {
        submitResetForm() {
            axios.defaults.headers.common['Authorization'] = `Token ${this.$store.state.api.auth.user.token}`;
            this.$refs.resetPasswordForm.validate((valid) => {
                if (valid) {
                    this.isSaving = true;
                    axios.post(`${window.config.api_root_url}/auth/change-password/`, {
                        password1: this.resetPasswordForm.password,
                        password2: this.resetPasswordForm.password,
                        email: this.currentUser.email,
                    }).then(() => {
                        this.$notify.success({
                            message: this.getText('form_reset_password_success'),
                        });
                        this.$refs.resetPasswordForm.resetFields();
                        this.$emit('resetResetForm');
                        this.isSaving = false;
                    }).catch(() => {
                        this.$notify.error({
                            message: this.getText('form_reset_password_fail'),
                        });
                        this.isSaving = false;
                    });
                } else {
                    this.$notify.error({
                        title: this.getText('form_reset_password_validation_error_title'),
                        message: this.getText('form_reset_password_validation_error_message'),
                    });
                    this.isSaving = false;
                    return false;
                }

            });
        },


        resetResetForm() {
            this.$refs.resetPasswordForm.resetFields();
            this.$emit('resetResetForm');
        },
    },
};
</script>

<style lang="less">
.reset-password-form {
    .el-form-item {
        width: 100%;
        margin: 20px 0;
    }
    .reset-password-form-buttons {
        margin-top: 20px;
    }
    .whiteButton, .greenButton {
        font-size: 15px;
        text-align: center;
        padding: 10px 0 8px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/formResetPassword.vue